// extracted by mini-css-extract-plugin
export default {"wrapper":"MMgJg_K0Q7JulG2DRJyo","homeLink":"hmAaaWZRUhO4fEv_ibsR","header":"ukioRCuor86075UySYNB"};